<script setup lang="ts">
import { usersSessions } from '@consumer/api'

defineProps<{
  credentials: {
    email?: string
    autoCreateAccount?: boolean
  }
}>()

const emit = defineEmits<{
  success: [{ isCorporate?: boolean }]
  unknown: []
  error: [error: any]
}>()

async function onSubmit (data: { email: string; autoCreateAccount?: boolean }) {
  try {
    if (data.email) {
      const emailInfo = await usersSessions.verifyEmail({ data })
      emit('success', emailInfo)
    }
    else {
      emit('unknown')
    }
  }
  catch (error: any) {
    if (error.response?.status === 404) {
      emit('unknown')
    }
    else {
      emit('error', error)
      throw error
    }
  }
}

defineExpose({ onSubmit })
</script>

<template>
  <GForm :model="credentials" :onSubmit="onSubmit" keepFields>
    <GInput
      v-autofocus
      field="email"
      type="email"
      label="Your Email"
      placeholder="Enter your email"
      class="w-full email-input-field"
      autocapitalize="off"
      autocomplete="email"
      required
    >
      <template #hint>
        <slot name="hint"/>
      </template>
    </GInput>
    <GSaveButton primary class="mt-4 w-full" name="login-submit-email" label="Next"/>
  </GForm>
</template>
